// extracted by mini-css-extract-plugin
export default {"root":"Toggle_root__-jJwb","knobs":"Toggle_knobs__omBRL","layer":"Toggle_layer__nSsCJ","btn":"Toggle_btn__b11Hf","checkbox":"Toggle_checkbox__2Rmtr"};